import { render, staticRenderFns } from "./ProductItemInventoryCreate.vue?vue&type=template&id=600e5761&"
import script from "./ProductItemInventoryCreate.vue?vue&type=script&lang=js&"
export * from "./ProductItemInventoryCreate.vue?vue&type=script&lang=js&"
import style0 from "./ProductItemInventoryCreate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports